// extracted by mini-css-extract-plugin
export default {"customer-organization-form__sales-channel__sales-channel-inputs-container":"SalesChannel_customer-organization-form__sales-channel__sales-channel-inputs-container__CVap0"};